var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { SyfLoader } from "syf-component-library/ui/atoms";
import ElectronicEnrollmentCard from "./ElectronicEnrollmentCard";
import PaperEnrollmentCard from "./PaperEnrollmentCard";
import { LoaderWrapper } from "./subcomponents";
import { accountTypes, enrollmentType as enrollmentTypes, } from "../../../const/enrollmentConsts";
import { useStatementsEnrollmentUpdate } from "../../../const/syfApiQueries";
import { useStatementsContext } from "../../../context/statementsContext";
import changeEnrollmentStatus from "../../../helpers/changeEnrollmentStatus";
import check24HourError from "../../../helpers/check24HourError";
var EnrollCard = function (_a) {
    var enrollmentType = _a.enrollmentType, availableEnrollmentType = _a.availableEnrollmentType;
    var _b = useStatementsContext(), dispatch = _b.dispatch, _c = _b.state, accountId = _c.accountId, isMutationLoading = _c.isMutationLoading;
    var _d = useState(false), is24HourError = _d[0], setIs24HourError = _d[1];
    var mutateAsync = useStatementsEnrollmentUpdate(accountId).mutateAsync;
    var enrollmentHandler = function (enrollType) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, error, errorStatus;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch({ isMutationLoading: true });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 7, 8]);
                    return [4 /*yield*/, mutateAsync({
                            "cipher.accountId": accountId,
                            accountIdType: accountTypes.GUID,
                            enrollmentType: changeEnrollmentStatus(enrollType),
                        })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 8];
                case 3:
                    e_1 = _b.sent();
                    error = e_1;
                    errorStatus = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
                    if (!(errorStatus && errorStatus === 422)) return [3 /*break*/, 5];
                    return [4 /*yield*/, check24HourError(error, setIs24HourError)];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    dispatch({ showEnrollmentError: true });
                    _b.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    dispatch({ isMutationLoading: false });
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    if (!availableEnrollmentType || enrollmentType === null) {
        dispatch({ showEnrollmentError: true });
        return null;
    }
    if (isMutationLoading) {
        return (_jsx(LoaderWrapper, { children: _jsx(SyfLoader, { size: 3 }) }));
    }
    // If user is enrolled in 'PAPER' only
    if (enrollmentType === enrollmentTypes.PAPER) {
        return (_jsx(PaperEnrollmentCard, { onEnroll: enrollmentHandler, is24HourError: is24HourError, enrollmentType: enrollmentType, availableEnrollmentType: availableEnrollmentType }));
    }
    // If user is enrolled in 'ELECTRONIC' or 'ELECTRONIC_AND_PAPER'
    return (_jsx(ElectronicEnrollmentCard, { enrollmentType: enrollmentType, availableEnrollmentType: availableEnrollmentType, onEnroll: enrollmentHandler }));
};
export default EnrollCard;
